import PropTypes from 'prop-types';
import React from 'react';

/** Small circled-i used beside labels like "Refund currency" / "Network". */
const InfoIcon = ({ title }) => (
  <svg
    className="resolve__info"
    width="13"
    height="13"
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    aria-label={title || 'info'}
  >
    <title>{title || 'info'}</title>
    <circle cx="8" cy="8" r="7" stroke="currentColor" />
    <path d="M8 7v4" stroke="currentColor" strokeLinecap="round" />
    <circle cx="8" cy="4.8" r="0.8" fill="currentColor" />
  </svg>
);

InfoIcon.propTypes = { title: PropTypes.string };

/** A single label / value row used by the refund detail + summary screens. */
const DetailRow = ({ label, value, info, testId }) => (
  <div className="resolve__row">
    <span className="resolve__row-label">
      {label}
      {info && <InfoIcon title={info} />}
    </span>
    <span className="resolve__row-value" data-testid={testId}>
      {value}
    </span>
  </div>
);

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  info: PropTypes.string,
  testId: PropTypes.string
};

export { DetailRow };
